import clip from 'text-clipper';

export const clipText = (str = '', len) => clip(str, len, { breakWords: true });
